@if (!isEmpty) {
  <ul>
    @for (item of list(); track item) {
      <li>
        <p>{{ item }}</p>
      </li>
    }
  </ul>
}

@if (isEmpty) {
  <p>{{ emptyText() }}</p>
}
